<template>
    <div>
        <Header/>
        <div class="Explain">--包庄批发网微信小程序管理后台系统</div>
        <Content/>
    </div>
</template>

<script>
import Header from '../compinent/Header.vue'
import Content from '../compinent/Content.vue'

export default {
  name: 'SignIn',
  components: {
    Header,
    Content
  }
}
</script>
<style scoped>
.Explain{
  color: black;
}
</style>
